export default __webpack_public_path__ + "static/media/2.94b9da04.png";